(function ($) {


    function initLogosMarquee($marquee, options) {
        const settings = $.extend({
            speed: 80,
            pauseOnHover: true
        }, options || {});

        if ($marquee.data('marquee-initialized')) {
            return;
        }

        $marquee.attr('data-marquee-initialized', true);

        const $initialItems = $marquee.children().not('.logos-marquee__track');
        const $track = $('<div class="logos-marquee__track js-marquee-track"></div>');
        const $group = $('<div class="logos-marquee__group js-marquee-group"></div>');

        $group.append($initialItems);
        $track.append($group);
        $marquee.append($track);

        let groupWidth = 0;
        let currentX = 0;
        let rafId = null;
        let lastTime = 0;
        let paused = false;

        function stop() {
            if (rafId) {
                cancelAnimationFrame(rafId);
                rafId = null;
            }
        }

        function buildClones() {
            $track.find('.js-marquee-group--clone').remove();

            groupWidth = Math.ceil($group.outerWidth(true)) - (parseInt($track.find('.js-marquee-group:first').css('padding-left')) || 0);

            if (!groupWidth) {
                return;
            }

            const containerWidth = Math.ceil($marquee.innerWidth());
            const clonesNeeded = Math.max(2, Math.ceil((containerWidth * 2) / groupWidth));

            for (let i = 0; i < clonesNeeded; i++) {
                $group
                    .clone()
                    .removeClass('js-marquee-group')
                    .addClass('js-marquee-group--clone')
                    .attr('aria-hidden', 'true')
                    .appendTo($track);
            }

            currentX = 0;
            $track.css('transform', 'translate3d(0, 0, 0)');
        }

        function tick(timestamp) {
            if (!lastTime) {
                lastTime = timestamp;
            }

            const delta = (timestamp - lastTime) / 1000;
            lastTime = timestamp;

            if (!paused && groupWidth > 0) {
                currentX -= settings.speed * delta;

                if (Math.abs(currentX) >= groupWidth) {
                    currentX += groupWidth;
                }

                $track.css('transform', 'translate3d(' + currentX + 'px, 0, 0)');
            }

            rafId = requestAnimationFrame(tick);
        }

        function start() {
            stop();
            lastTime = 0;
            rafId = requestAnimationFrame(tick);
        }

        function rebuild() {
            stop();
            buildClones();
            start();
        }

        if (settings.pauseOnHover) {
            $marquee.on('mouseenter', function () {
                paused = true;
            });

            $marquee.on('mouseleave', function () {
                paused = false;
            });
        }

        let resizeTimer = null;

        $(window).on('resize', function () {
            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(function () {
                rebuild();
            }, 150);
        });

        const $images = $marquee.find('img');
        let pending = 0;

        $images.each(function () {
            if (!this.complete) {
                pending++;

                $(this).one('load error', function () {
                    pending--;

                    if (pending === 0) {
                        rebuild();
                    }
                });
            }
        });

        rebuild();
    }


    $(document).on('ready', function () {

        $('.js-logos-marquee').each(function () {
            initLogosMarquee($(this), {
                speed: 80,
                pauseOnHover: true
            });
        });

    });


})(jQuery);